<template>
    <div class="body-info body-content-description body-catalog-content has-footer-absolute" :class="{ 'themed-scrollbar' : isDesktop, 'content-max-vh' : toggleCatalog }">
        <MuffinLoader v-if="isLoading && !isDesktop" :class="{ 'full-page' : !isDesktop}"/>
        <div v-if="!toggleCatalog && !innerComponent" class="catalog-cart-wrapper">
            <!-- maybe this can be a component -->
            <div class="saved-list-container full-height" :class="{ 'has-items' : selectedProductsList.length }">
                <div v-if="selectedProductsList" class="product-shop-list themed-scrollbar">
                    <div v-for="item in selectedProductsList" class="shop-item" :id="'shop-item-' + item.groupId">
                        <img :src="item.img" class="item-img" :alt="item.name"/>
                        <div class="mx-0 item-info-container">
                            <div class="prod-labels">
                                <p class="item-label name-label"> {{ item.name }} </p>
                                <p class="item-label light variant-label"> {{ item.label }} </p>
                            </div>
                            <div class="mt-auto action-labels">
                                <p class="item-label light qty-label"> {{ kStrings.kQUANTITY + ': ' }} <span> {{ item.quantity ? item.quantity : 1 }} </span> </p>
                            </div>
                        </div>
                        <i class="ecom-close remove-selected" @click="listHandler(item)"/>
                    </div>
                </div>
            </div>
            <div class="button-wrapper">
                <button class="pastime-button light" @click.prevent="loadCategories()">
                    {{ selectedProductsList.length ? kStrings.kADD_MORE : kStrings.kADD_PRODUCT_RECIPES }}
                </button>
            </div>
        </div>
        <!-- v-show for cursed refs & listeners -->
        <div v-show="toggleCatalog" class="catalog-cart-wrapper">
            <div class="input-wrapper search-wrapper">
                <i class="ecom-search left-pos"/>
                <input v-model="searchField" @input="debounceMethod" class="normal-input free-label" :placeholder="kStrings.kSEARCH_CATEGORY + '...'"  type="search" id="pastimesCatalogSearch"/>
                <i v-if="searchField" @click="clearSearchField" class="ecom-close"/>
            </div>
            <div class="picker-slider-wrapper">
                <div v-show="!scrollStart" class="slide-control pos-left" @click="controlDir()">
                    <i class="ecom-chevron-left"/>
                </div>
                <div v-if="productCategories" class="category-slide-picker" id="categorySlidePicker" ref="categorySlidePicker" @scroll="categoriesScrollEvent">
                    <div v-for="(cat, index) in productCategories" 
                         class="category-item"
                         :class="{ 'selected' : selectedCategory == cat.id, 'last' : index == productCategories.length - 1 }" 
                         :id="cat.id"
                         @click.prevent="getProducts(cat.id, 1)"
                    >
                        {{ cat.name }}
                    </div>
                </div>
                <div v-show="!isScrolledMax" class="slide-control" @click="controlDir(1)">
                    <i class="ecom-chevron-right"/>
                </div>
            </div>
            <CatalogProductShop v-if="filteredProducts" 
                                :can-select-products="canSelectProducts"
                                @catalog-request="getProducts"
                                @list-handler="listHandler"
            />
            <div v-if="searchField.length >= 2 && !filteredProducts" class="results-title">
                {{ this.kStrings.kEVT_RESULTS_SEARCH_EMPTY + ': ' + '"' + this.searchField + '"'  }}
            </div>
        </div>
        <!-- footer -->
        <div v-if="!toggleCatalog" class="button-wrapper fit-content modal-absolute">
            <button class="pastime-button dark-mode" @click.prevent="saveProductList" :disabled="!enableSubmit" id="btnProdList">
                {{ kStrings.kSAVE_CHANGES }}
            </button>
        </div>
        <div v-else class="button-wrapper fit-content modal-absolute">
            <button v-if="isDesktop" class="pastime-button light mr-3" @click.prevent="actionHandler(true)" :disabled="false">
                <i class="ecom-chevron-left"/>
                {{ kStrings.kGLOB_GO_BACK }}
            </button>
            <button v-if="isDesktop" class="pastime-button dark-mode" @click.prevent="actionHandler(false, true)" :disabled="!selectedProductsList.length">
                {{ kStrings.kADD }}
            </button>
            <button v-if="!isDesktop && selectedProductsList.length > 0" class="pastime-button dark-mode" @click.prevent="actionHandler(false, true)" :disabled="!selectedProductsList.length">
                {{ kStrings.kADD }}
            </button>
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty, debounce} from 'lodash-es';

import utilities from '@/Utilities/common';

import MuffinLoader from '@/components/Muffin/Loader';
import CatalogProductShop from '@/components/Pastimes/Desktop/sections/CatalogProductShop';
import request from '@/Utilities/httpRequest';

export default {
    store,
    name: 'CatalogCart',
    components: {
        CatalogProductShop,
        MuffinLoader
    },
    props: {
        innerComponent: {type: Boolean, default: false}
    },
    data() {
        return {
            toggleCatalog: false,
            searchField: '',
            categorySlidePickerElm: null,
            scrollStart: false,
            isScrolledMax: false,
            selectedCategoryIndex: 0, // TODO: remove it
            selectedCategory: null,
            page: 0,
            pages: 0,
            originalList: [],
            //productListToSave: [],
            //temporarySelection: [],
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        urls() {
            return this.$store.getters.urls;
        },
        isLoading() {
            return this.$store.getters.loading;
        },
        enableSubmit() { 
            return this.selectedProductsList.length > 0;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalSubTitle() {
            let formattedTitle = this.selectedProductsList.length + ' ' + this.kStrings.kPRODUCTS_SELECTED;
            this.$emit('set-sub-header', formattedTitle);
            return formattedTitle;
        },
        sliderPickerScrollable() {
            return this.categorySlidePickerElm ? utilities.isScrollableElement(this.categorySlidePickerElm) : false;
        },
        selectedProductsList() { // store product list to submit
            const list = this.$store.getters['registrationPage/selectedProductsList'];
            return !isEmpty(list) ? list : [];
        },
        productCategories() {
            const list = this.$store.getters['registrationPage/productCategories'];
            return !isEmpty(list) ? list : null
        },
        filteredProducts() {
            const list = this.$store.getters['registrationPage/productList'];
            return !isEmpty(list) ? list : null
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        isTypeRecipe() {
            return this.pastimeInfo.detailedInfo.isRecipe;
        },
        canSelectProducts(){
            const info = this.pastimeInfo.baseInfo;
            if(!info || !info.maxSelProducts){
                return true;
            }
            return this.selectedProductsList.length < info.maxSelProducts;
        }
    },
    watch: {
        selectedProductsList(value) {
            //if(value && value.length > 0) {
                let selectedCount = !isEmpty(value) ? value.length : 0;
                let formattedTitle = selectedCount + ' ' + this.kStrings.kPRODUCTS_SELECTED;
                this.$emit('set-sub-header', formattedTitle);
            //}
        },
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            // clear list
            this.$store.dispatch('registrationPage/setProductListData', {});
            this.originalList = JSON.parse(JSON.stringify(this.selectedProductsList));
            // test emit
            this.$emit('set-sub-header', this.modalSubTitle);
            if(this.innerComponent) {
                this.loadCategories();
            }
        });
    },
    methods: {
        loadSliderEvent() {
            this.categorySlidePickerElm = this.$refs.categorySlidePicker;
            if(!this.categorySlidePickerElm) {
                this.categorySlidePickerElm = document.getElementById('categorySlidePicker');
            }
            if(this.categorySlidePickerElm) {
                this.scrollStart = (this.categorySlidePickerElm.scrollLeft) < 16;
            }
        },
        categoriesScrollEvent() {
            if(this.categorySlidePickerElm){
                this.scrollStart = (this.categorySlidePickerElm.scrollLeft) < 16;
                this.isScrolledMax = utilities.elementFullScrolledHorizontal(this.categorySlidePickerElm);
            }
        },
        controlDir(dir) {
            if(!this.categorySlidePickerElm) {
                this.categorySlidePickerElm = document.getElementById('categorySlidePicker');
            }
            
            this.categorySlidePickerElm.scrollBy({left: dir ? 100 : -100, behavior: 'smooth'});
        },
        async loadCategories() {
            this.$store.dispatch('setLoading', true);
            const data = await request.get(this.urls.menuCatalog);
            await this.$store.dispatch('registrationPage/setProductCategories', data.data);
            this.loadSliderEvent();
            // load products for first category (should be "all products")
            await this.getProducts(this.productCategories[0].id);
            this.$store.dispatch('setLoading', false);
            this.toggleCatalog = true;
        },

        listHandler(prod = null) { // adds / remove items from selection
            if(prod) {
                let found = this.selectedProductsList.find(item => item.groupId == prod.groupId);
                if(!found) {
                    //this.productListToSave.push(prod);
                    this.$store.dispatch('registrationPage/addSelectedProducts', prod)
                    //this.temporarySelection.push(prod);
                } else {
                    this.$store.dispatch('registrationPage/removeSelectedProducts', prod)
                    //this.productListToSave = this.productListToSave.filter(item => item.groupId != prod.groupId);
                    //this.temporarySelection = this.temporarySelection.filter(item => item.groupId != prod.groupId);
                }
            }
        },
        updateProductList(removeTemp = false) {
            if(removeTemp) {
                //console.log('cancel update');
                //console.log('this.originalList', this.originalList)
                this.$store.dispatch('registrationPage/setSelectedProductsList', this.originalList);
                // let list = this.selectedProductsList.filter((objFromA) => {
                //     return !this.temporarySelection.find((objFromB) => {
                //         return objFromA.groupId === objFromB.groupId;
                //     });
                // });
                // this.$store.dispatch('registrationPage/setSelectedProductsList', list);
                // this.temporarySelection = [];
            }
            
            // cursed design changes
            if(this.innerComponent) {
                this.$store.dispatch('setModalStatus', {status: true, context: this.isTypeRecipe ? 'recipeForm' : 'descriptionForm', isMixType: true});
            }
        },
        async saveProductList() {
            //if(this.productListToSave.length) {
                //await this.$store.dispatch('registrationPage/setSelectedProductsList', this.productListToSave);
            //}
            //this.temporarySelection = [];
            if(!this.innerComponent) {
                this.$store.dispatch('setModalStatus', {status: false, context: null});
            } else {
                this.$store.dispatch('setModalStatus', {status: true, context: this.isTypeRecipe ? 'recipeForm' : 'descriptionForm', isMixType: true});
            }
        },

        // get products
        async getProducts(category, page) {
            const text = this.searchField; // this is binded to v-model
            if(text && text.trim().length == 1) {
                // don't search if string is less than 2 characters 
                return;
            }
            if(category){
                // forcing category
                this.selectedCategory = category;
            }
            const params = {
                text: this.searchField,
                category: this.selectedCategory,
                page: page ? page : this.page+1,
            };
            this.$store.dispatch('setLoading', true);
            const {data} = await request.get( this.urls.catalogUrl, params);
            //console.log('get products result: ', data);
            await this.$store.dispatch('registrationPage/setProductListData', data);
            this.page = data.page;
            this.pages = data.pages;
            this.$store.dispatch('setLoading', false);
        },
        debounceMethod: debounce(function(e) {
             //console.log('search input: ', e.target.value);
             this.getProducts(null, 1);
        }, 1000),
        clearSearchField() {
            this.searchField = '';
            this.getProducts(null, 1);
        },
        // for new design flow changes 
        actionHandler(back = false, add = false) {
            this.toggleCatalog = false;
            if(back) { // on back -> cancel list update
                this.updateProductList(true);
            }
            
            if(add && this.innerComponent) { // on add (new design) 
                this.saveProductList();
            }
        }
    }
};
</script>

<style scoped>

</style>